import { DefaultSkin } from './default';
import { SublimeSkin } from './sublime';
import { YoutubeSkin } from './youtube';
import { MovietimeSkin } from './movietime';
import { SimpleSkin } from './simple';
import { MinimalSkin } from './minimal';

export const getSkin = (name) => {
    switch(name) {
        case 'youtube':
            return YoutubeSkin;
        case 'sublime':
            return SublimeSkin;
        case 'movietime':
            return MovietimeSkin;
        case 'simple':
            return SimpleSkin;
        case 'minimal':
            return MinimalSkin;
        default:
            return DefaultSkin;
    }
}